import React, { useState, useEffect } from "react";

import { useTheme } from "@mui/material/styles";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";

// import { DotsIcon } from "../Svg";

// api URLS
import ViewModal from "../../components/ViewModal";
import { ApiUrls } from "../../Services/Routes/API";
import { headersGet } from "../../Services/API";
import { MainRoutes } from "../../Services/Routes/App";
import { DotsIcon } from "../../Svg";
import {
  Typography,
  Paper,
  Button,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  TableBody,
  TableCell,
  Box,
  Stack,
  Menu,
  MenuItem,
  Tabs,
  Tab,
  tabsClasses,
} from "@mui/material";
import { format } from "date-fns";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const useStyles = makeStyles({
  cardHead: {},
  cardText: {
    fontWeight: 600,
  },
  paper: {
    borderRadius: 1,
    height: 300,
  },
  typographystyle: {
    marginLeft: 16,
  },
  tableHead: {
    textAlign: "left",
    fontWeight: 500,
    letterSpacing: "0.3px",
    color: "#C4C4C4",
  },
  tableData: {
    align: "left",
  },
  list: {
    overflowY: "auto",
    margin: 0,
    padding: 0,
    listStyle: "none",
    height: "100%",
    "&::-webkit-scrollbar": {
      width: "0.1em",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,0)",
      outline: "1px solid white",
    },
  },
  muiPaperShadowNone: {
    "& .MuiPaper-root": {
      boxShadow: "0px 3px 4px 0px rgb(30 63 138 / 3%)",
      minWidth: "100px",
    },
  },
});

const images = [
  {
    imgPath: "banking.jpg",
  },
  {
    imgPath: "banking.jpg",
  },
  {
    imgPath: "banking.jpg",
  },
  {
    imgPath: "banking.jpg",
  },
];

function TransactionTable() {
  const theme = useTheme();
  const classes = useStyles();
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = React.useState(0);
  const [transactionsList, setTransactionsList] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(false);
  const [tabValue, setTabValue] = useState("all_transactions");
  const [categorizedTransactions, setCategorizedTransactions] = useState({});
  const [transactionRow, setTransactionRow] = useState({});
  const [openView, setOpenView] = useState(false);

  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  const handleTabsChange = (event, newValue) => {
    setTransactionsList(categorizedTransactions?.[newValue]);
    setTabValue(newValue);
  };

  const updateUserData = (item) => {
    setTransactionRow(item);
    setOpenView(true);
  };


  const headings = [
    "Beneficiary",
    "Amount",
    "Reference ID",
    "Date",
    "Status",
    " Actions",
  ];

  // rows

  const rows = [
    {
      benificary: "DSTV",
      payment_type: "Cable Subscription",
      company_number: "024578935",
      second_time: "7:30pm",
      amount: "-N5,000",
      reference_Id: " 571654168874",
      Date: "06/05/2021;7:30pm",
      status: "RSVL",
    },
    {
      benificary: "Maitama, Abuja",
      payment_type: "Funds Transfer",
      company_number: "024578935",
      second_time: "7:30pm",
      amount: "-N5,000",
      reference_Id: " 571654168874",
      Date: "06/05/2021;7:30pm",
      status: "RSVL",
    },
    {
      benificary: "Maitama, Abuja",
      payment_type: "Funds Transfer",
      company_number: "024578935",
      second_time: "7:30pm",
      amount: "+N5,000",
      reference_Id: " 571654168874",
      Date: "06/05/2021;7:30pm",
      status: "Successful",
    },
    {
      benificary: "Maitama, Abuja",
      payment_type: "Funds Transfer",
      company_number: "024578935",
      second_time: "7:30pm",
      amount: "+N5,000",
      reference_Id: " 571654168874",
      Date: "06/05/2021;7:30pm",
      status: "Successful",
    },
    {
      benificary: "Maitama, Abuja",
      payment_type: "Funds Transfer",
      company_number: "024578935",
      second_time: "7:30pm",
      amount: "+N5,000",
      reference_Id: " 571654168874",
      Date: "06/05/2021;7:30pm",
      status: "Succesful",
    },
  ];

  const openn = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setTabValue("all_transactions");
    setTransactionsList(categorizedTransactions?.all_transactions);
  }, [categorizedTransactions]);

  const getAllTransactionData = () => {
    // setOpen(true);
    headersGet(ApiUrls?.GET_ALL_TRANSACTIONS_DATA)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setCategorizedTransactions(res?.data?.categorized_transactions);
          // setOpen(false);
        } else {
          // setAlertOpen(true);
          // setAlertMsg(res?.data?.message);
          // setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          // setAlertOpen(true);
          // setAlertMsg(response?.statusText);
          // setAlertIcon("error");
        }
      });
  };

  useEffect(() => {
    getAllTransactionData();
  }, []);

  return (
    <Box sx={{ mt: 2 }}>
      <Paper className={classes.list} elevation={1}>
        <Box sx={{ width: "100%" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabsChange}
            variant="scrollable"
            //   scrollButtons
            sx={{
              [`& .${tabsClasses.scrollButtons}`]: {
                "&.Mui-disabled": { opacity: 0.3 },
              },
            }}
          >
            <Tab label="All Transactions" value="all_transactions" />
            <Tab label="Transfer" value="transferred" />
            <Tab label="Receive" value="received" />
            <Tab label="Withdraw" value="withdrawn" />
            <Tab label="Request" value="requests" />
          </Tabs>
        </Box>
        <Box>
          <TableContainer
            sx={{ overflow: "hidden", width: "100%" }}
            component={Paper}
          >
            <Table
              sx={{ minWidth: 650, height: "200px" }}
              aria-label="simple table"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  {headings?.map((h, index) => {
                    {
                      return (
                        <TableCell
                          sx={{ color: "#C4C4C4", fontWeight: 500 }}
                          className={classes.tableHead}
                          key={`${index}-table-heading-${h}`}
                        >
                          {h}
                        </TableCell>
                      );
                    }
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {transactionsList?.map((row, index) => (
                  <TableRow key={`${index}-row.name-${index + 2}`}>
                    <TableCell>
                      <Stack direction={"column"}>
                        <Typography> {row?.name_on_card}</Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#666666",
                          }}
                        >
                          {" "}
                          {row?.action}
                        </Typography>
                      </Stack>
                    </TableCell>
                    <TableCell
                      sx={{
                        color: theme.palette.success.main,
                        fontWeight: 500,
                      }}
                    >
                      <Typography
                        sx={{
                          color:
                            row?.amount === "-" + ""
                              ? theme.palette.error.main
                              : theme.palette.success.main,
                          fontWeight: 500,
                        }}
                      >
                        {row?.amount}
                      </Typography>
                      <Typography
                        variant="body2"
                        component={"span"}
                        sx={{
                          color: "#666666",
                        }}
                      >
                        {row?.id || "N/A"}
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "black",
                      }}
                    >
                      <Typography> Ref:{row?.slug || "N/A"}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        {row?.created_at
                          ? format(
                              new Date(row?.created_at),
                              "MM/dd/yyyy; hh:mm "
                            )
                          : ""}
                      </Typography>
                      <Typography
                        variant="body2"
                        component={"span"}
                        sx={{
                          color: "#666666",
                        }}
                      >
                        {row?.created_at
                          ? format(new Date(row?.updated_at), "hh:mm ")
                          : ""}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        sx={{
                          color:
                            row?.status === "RSVL"
                              ? theme.palette.error.main
                              : theme.palette.success.main,
                        }}
                      >
                        {" "}
                        {row?.status}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <TableCell align="center" sx={{ border: "none" }}>
                      <Button
                            id={`basic-button-${row?.id}`}
                            aria-controls={open ? "basic-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                            onClick={handleClick}
                            // variant="outlined"
                            // onClick={() => addHandler(row)}
                            sx={{
                              borderRadius: 1,
                              minWidth: 0,
                              backgroundColor: "transparent",
                              padding: 0,
                            }}
                          >
                            <DotsIcon />
                          </Button>
                          <Menu
                            id={`basic-menu-${row?.id}`}
                            anchorEl={anchorEl}
                            open={anchorEl?.id === `basic-button-${row?.id}`}
                            onClose={handleClose}
                            MenuListProps={{
                              "aria-labelledby": "basic-button",
                            }}
                            className={classes.muiPaperShadowNone}
                          >
                            <MenuItem
                              onClick={() => {
                                updateUserData(row);
                              }}
                            >
                              View
                            </MenuItem>

                            <MenuItem onClick={handleClose}>Share</MenuItem>
                            <MenuItem onClick={handleClose}>Delete</MenuItem>
                          </Menu>
                      </TableCell>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <ViewModal
        open={openView}
        onClose={() => {
          setOpenView(false);
        }}
        row={transactionRow}
      />
        </Box>
      </Paper>
    </Box>
     
  );
}

export default TransactionTable;
